import React from 'react'
import i18next from 'i18next'
import { Button, Form, Row, Col } from 'react-bootstrap'
import hash from 'object-hash'
import { Trans } from 'react-i18next'

const { t } = i18next

class CategoryForm extends React.Component {
  static defaultProps = {
    category: {},
    errors: {},
    readonly: false,
    onSave: () => {},
    closeForm: () => {},
    updateErrors: () => {},
  }

  state = {
    id: null,
    name: '',
    enabled: true,

    category_hash: '',
  }

  initialHash = ''

  constructor(props) {
    super(props)
    if (props.category.id) {
      let { id, name, enabled } = props.category
      this.state.id = id
      this.state.name = name
      this.state.enabled = enabled
    }

    // eslint-disable-next-line no-unused-vars
    let { category_hash, ...rest } = this.state
    this.initialHash = hash(rest)
    this.state.category_hash = this.initialHash
  }

  updateHash = () => {
    // eslint-disable-next-line no-unused-vars
    let { category_hash, ...rest } = this.state
    this.setState({ category_hash: hash(rest) })
  }

  handleChange = ({ target: { name, value } }) => {
    let errors = { ...this.props.errors }
    if (name in errors) {
      delete errors[name]
      this.props.updateErrors({ errors })
    }
    this.setState({ [name]: value }, () => this.updateHash())
  }

  handleChangeCheckbox = ({ target: { name } }) => {
    this.setState({ [name]: !this.state[name] }, () => this.updateHash())
  }

  handleConfirm = () => {
    // eslint-disable-next-line no-unused-vars
    let { category_hash, ...rest } = this.state
    this.props.onSave(rest)
  }

  isFormValid = () => {
    let { name } = this.state
    return name !== ''
  }

  componentWillUnmount() {
    this.props.updateErrors({})
  }

  render() {
    let { name, enabled } = this.state

    return (
      <>
        <div className="flex-fill position-relative overflow-auto">
          <div className="container">
            <Form.Group className="mb-3 mt-2">
              <Form.Label>
                <Trans i18nKey="components.categories.show_catgory">Attiva categoria</Trans>
              </Form.Label>
              <Form.Check
                type="switch"
                id="enabled"
                name="enabled"
                checked={enabled === true}
                label={t('components.categories.show_category', 'Abilitato')}
                disabled={this.props.readonly}
                onChange={this.handleChangeCheckbox}
              />
              <Form.Text id="enabledHelp" muted>
                <Trans i18nKey="components.categories.lock_help">
                  Selezionando questo flag permette la visualizzazione della categoria nelle visite
                </Trans>
              </Form.Text>
            </Form.Group>
            <Row>
              <Form.Group as={Col} md="6" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.categories.name">Nome</Trans>
                </Form.Label>
                <span> *</span>
                <Form.Control
                  name="name"
                  placeholder={t('components.categories.name', 'Nome')}
                  value={name}
                  onChange={this.handleChange}
                  disabled={this.props.readonly}
                  isInvalid={'name' in this.props.errors}
                />
                <Form.Control.Feedback type="invalid">{this.props?.errors?.name ?? ''}</Form.Control.Feedback>
              </Form.Group>
            </Row>
          </div>
        </div>
        <div className="border-top pt-2">
          {this.props.readonly === false && (
            <Button
              className="float-end"
              variant="primary"
              disabled={!this.isFormValid() || this.initialHash === this.state.category_hash}
              onClick={this.handleConfirm}>
              <Trans i18nKey="buttons.confirm">Conferma</Trans>
            </Button>
          )}

          <Button className="float-end me-2" variant="secondary" onClick={this.props.closeForm}>
            <Trans i18nKey="buttons.cancel">Annulla</Trans>
          </Button>
        </div>
      </>
    )
  }
}
export default CategoryForm
